/* Rolling month/year helpers shared by Projects and Invoices pages */

export function generateRolling12Months(locale = 'en') {
	const months = [];
	const now = new Date();
	const localeTag = locale === 'et' ? 'et-EE' : 'en-US';

	for (let i = 0; i < 12; i++) {
		const date = new Date(now.getFullYear(), now.getMonth() - i, 1);
		const year = date.getFullYear();
		const month = date.getMonth() + 1;
		const monthName = date.toLocaleString(localeTag, { month: 'long' });

		months.push({
			label: `${monthName} ${year}`,
			value: `${year}-${month}`,
		});
	}

	return months;
}

export function parsePeriodValue(periodValue) {
	if (periodValue && periodValue.includes('-')) {
		const [y, m] = periodValue.split('-');
		return { year: y, month: m };
	}
	return { year: '', month: '' };
}

export function resolveMonthYearParams(month, year) {
	let yearParam = year;
	let monthParam = month;
	if (month && month.includes('-')) {
		const { year: y, month: m } = parsePeriodValue(month);
		yearParam = y;
		monthParam = m;
	}
	return { year: yearParam, month: monthParam };
}
